export default {
  data () {
    return {
      message: ''
    }
  },
  watch: {
    rewards: {
      handler (value) {
        // this is used on the creation screen
        this.updateRewards(value)
      },
      deep: true
    },
    // rewards: {
    //   handler (value) {
    //     this.updateRewards(value)
    //   },
    //   deep: true
    // },
    messageProps: {
      handler (value) {
        this.updateRewardProps(value)
      },
      deep: true
    }
  },
  beforeDestroy () {
    // debugger
  },
  methods: {
    rewardComponents () {
      // const reward = this.reward
      const rewards = this.rewards
      const updateRewards = this.updateRewards
      const updateRewardProps = this.updateRewardProps
      const updateRewardPolygon = this.updateRewardPolygon

      if (!AFRAME.components.rewardmessage) {
        AFRAME.registerComponent('rewardmessage', {
          init () {
            // this works on non-creation screen...
            updateRewards(rewards)
          },
          update (oldData, newData) {
            // not working - not sure what it was for
            // const data = this.data
            // const el = this.el
            // const geo = el.object3D
            // const rewardplane = document.querySelector('[rewardmessage]')
            // // not perfect
            // if (rewardplane) {
            //   rewardplane.getObject3D(
            //     'mesh'
            //   ).geometry = new THREE.PlaneGeometry(
            //     geo.quaternion.w,
            //     geo.quaternion.y
            //   )
            // }
          },
          remove () {
            delete AFRAME.components.rewardmessage
          }
        })
      }
    },
    updateRewards (rewards) {
      console.log('updaterewards ', rewards)
      if (rewards.length > 0) {
        const rewardsContainer = document.querySelector('[rewards-container]')
        rewards.forEach((reward, index) => {
          if (reward.props) {
            const hitbox = document.createElement('a-entity')
            hitbox.setAttribute('geometry', `primitive: box; height: ${reward.props.height}; width: ${reward.props.width}; depth: ${reward.props.depth ? reward.props.depth : 1}`)
            hitbox.setAttribute('material', 'color: white; side: double')
            // hitbox.setAttribute('text', 'color: black; wrapCount: 30; baseline: center; anchor: left;')
            hitbox.setAttribute('position', { x: reward.props.positionX, y: reward.props.positionY, z: reward.props.positionZ })
            hitbox.setAttribute('text', 'anchor: center; width: 1.5; color: white; value: ' + reward.message)
            hitbox.setAttribute('class', 'clickable')

            rewardsContainer.appendChild(hitbox)
            this.updateRewardProps(reward.props, hitbox)

            if (reward.url || reward.play) {
              setTimeout(() => {
                hitbox.addEventListener('click', (e) => {
                  console.log('Reward clicked:', reward)
                  this.$nuxt.$emit('actionClick', { link: reward.url, play: reward.play })
                })
              }, 100)
            }
          }
          // updateReward(reward.message, reward.url, reward.props)
          if (reward.polygon) {
            this.updateRewardPolygon(reward.polygon, reward.url)
          }
        })
      }
    },
    updateClickable () {
      debugger
      const rewardsContainer = document.querySelector('[rewards-container]')
      for (const hotspot of rewardsContainer.children) {
        hotspot.setAttribute('class', 'clickable')
      }
    },
    // updateReward (message, link, props) {
    //   const rewardElement = document.querySelector('[rewardmessage]')
    //   this.message = message
    //   if (rewardElement && message && message !== '') {
    //     rewardElement.setAttribute('text', 'value', message)
    //     rewardElement.setAttribute('visible', true)
    //     rewardElement.setAttribute('scale', '15 15 15')
    //   } else {
    //     rewardElement.setAttribute('visible', false)
    //   }
    //   if (link) {
    //     rewardElement.addEventListener('click', (e) => {
    //       debugger
    //       this.$nuxt.$emit('actionClick', link)
    //     })
    //   }
    //   if (props) { this.updateRewardProps(props) }
    // },
    updateRewardProps (rewardProps, rewardElement) {
      // const rewardElement = document.querySelector('[rewardmessage]')
      // const rewardBox = document.querySelector('[reward-box]')
      if (rewardElement) {
        rewardElement.setAttribute('text', 'color', rewardProps.text)
        rewardElement.setAttribute('text', 'width', rewardProps.fontSize)
        rewardElement.setAttribute('material', 'color', rewardProps.background)
        rewardElement.setAttribute('text', 'wrapCount', rewardProps.wrapCount)
        if (rewardProps.asHotspot) {
          rewardElement.setAttribute('material', 'transparent', true)
          rewardElement.setAttribute('material', 'opacity', 0.0)
        } else {
          rewardElement.setAttribute('material', 'transparent', false)
          rewardElement.setAttribute('material', 'opacity', 1.0)
        }

        rewardElement.setAttribute('position', `${rewardProps.positionX}, ${rewardProps.positionY}, ${rewardProps.positionZ}`)

        rewardElement.setAttribute('rotation', `0, ${rewardProps.rotation}, 0`)
      }
    },
    updateRewardPolygon (polygon, link) {
      const rewardPolygon = document.getElementById('rewardPolygon')
      rewardPolygon.setAttribute('visible', true)

      if (link) {
        rewardPolygon.addEventListener('click', (e) => {
          this.$nuxt.$emit('actionClick', { link })
        })
      }
      rewardPolygon.addEventListener('model-error', function (evt) {
        console.log('The reward poly entity didnt load: ' + evt.type)
        // setDefaultModel()
      })
      rewardPolygon.addEventListener('model-loaded', function (evt) {
        console.log('The reward poly entity loaded: ' + evt.type)
      })
      if (polygon && polygon.formats && polygon.formats.length) {
        polygon.formats.forEach(async (format) => {
          if (
            format.formatType === 'GLB' ||
            format.formatType === 'GLTF' ||
            format.formatType === 'GLTF2'
          ) {
            if (
              rewardPolygon &&
              format.root.contentType === 'model/gltf+json'
            ) {
              await rewardPolygon.setAttribute(
                'gltf-model',
                format.root.url
              )
            }
          }
        })
      }
    }
  }
}
